<template>
  <div ref="container" class="autoresizing-textarea">
    <b-input
      ref="field"
      type="textarea"
      :value="value"
      :required="required"
      :placeholder="placeholder"
      :readonly="readonly"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import Vue from "vue";

export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    minHeight: {
      type: Number,
      default: 0
    }
  },
  computed: {
    textarea() {
      return this.$refs.field
        ? this.$refs.field.$el.getElementsByTagName("textarea")[0]
        : null;
    }
  },
  watch: {
    value(value) {
      this.resize();
      // Check if the textarea's input hasn't been updated yet. If so, schedule
      // another resize on the next event loop.
      if (this.textarea.value != value) {
        Vue.nextTick(this.resize);
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.resize);
    this.resize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      const borderHeight =
        this.textarea.offsetHeight - this.textarea.clientHeight;

      // Here are the steps to resize the container:
      // 1. Fix the height of the container - prevents the scroll position
      //    changes
      // 2. Reset the height of the textarea causing it to shrink to the
      //    minimum height
      // 3. Set the textarea height to the size of its contents (or the min height)
      // 4. Reset the height of the container
      this.$refs.container.style.height = `${this.$refs.container.clientHeight}px`;
      this.textarea.style.height = "";
      this.textarea.style.height = `${Math.max(
        this.minHeight,
        this.textarea.scrollHeight + borderHeight
      )}px`;
      this.$refs.container.style.height = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.autoresizing-textarea {
  ::v-deep .textarea {
    max-height: none;
    min-height: 0;
  }
}
</style>
